<template>
	<div class="letter">
		<div class="information-hr"></div><div class="information-hr2"></div>
		<!--<el-button @click="test">123456</el-button>-->
		<div class="privatetip">
			<el-select v-model="read_status" placeholder="全部" class="w150">
			  <el-option label="全部" value="0"></el-option>
		      <el-option label="未读" value="1"></el-option>
		      <el-option label="已读" value="2"></el-option>
		    </el-select>
		    <el-select v-model="sendType" placeholder="接收的私信" class="w150">
		      <el-option label="所有" value="0"></el-option>
		      <el-option label="发送的私信" value="1"></el-option>
		      <el-option label="接收的私信" value="2"></el-option>
		    </el-select>
			<el-select v-model="sort" placeholder="排序" class="w150">
		      <el-option label="时间降序" value="1"></el-option>
		      <el-option label="时间升序" value="2"></el-option>
		    </el-select>
		    <el-button type="primary" round @click.once="readAll">全部标为已读</el-button>
	    </div>
		<div class="letter-main" v-for="(item,index) in items" :key='index'>
           <div class="letter-read" :style="{color:item.color}"><span @click="oneRead(item.id)">{{item.ifread}}</span></div>
           <div class="letter-img">
           	  <img class="personIcon" :src="imgUrl" v-if="item.type == 1" />
           	  <img class="personIcon" src="../assets/img/admin.png" v-else/>
           	</div>
           <div class="letter-info">
           	  <div class="letter-name"><span>{{item.type == 1 ? '我':'管理员'}}</span>|<span>{{item.account}}</span></div>
           	  <div class="letter-text">{{item.content}}</div>
           </div>
           <div class="letter-right">
           	  <div class="letter-time">{{item.created_at}}</div>
           	  <div class="letter-more">
           	  	<span @click="replay(item)">查看详情/回复</span>
           	  	<span @click="deleteLetter(item)">删除</span>
           	  </div>
           </div>
		</div>
		<el-pagination class="fen" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total" style="text-align: center;">
		</el-pagination>
        <div v-show="isShow">
			<div class="letter-div">
				<div class="div">
					<img class="letterimg" :src="imgUrl" v-if="type == 1"/>
					<img class="letterimg" src="../assets/img/admin.png" v-else/>
					<p class="time">{{mytime}} <span @click="replayN(myid,type,account)" style="color: dodgerblue;cursor: pointer;">回复</span></p>
					<div class="rightMsg">
						<div v-if="type == 1" class="anname">我</div>
						<div v-else class="anname"><span>管理员 </span> | <span> {{account}} </span></div>
					    <p class="msgOver" v-for="item in mymsg">{{item}}</p>
					    <div class="letter-div-1" v-for="(child,index) in myanswer" :key='index'>
							<div class="div1">
								<img class="letterimg" :src="imgUrl" v-if="child.type == 1"/>
							    <img class="letterimg" src="../assets/img/admin.png" v-else/>
								<p class="time">{{child.created_at}} <span @click="replayN(child.id,child.type,child.account)" style="color: dodgerblue;cursor: pointer;">回复</span></p>
								<div class="rightMsg1">
									<div v-if="child.type == 1" class="morename">我</div>
									<div v-else class="morename"><span>管理员 </span> | <span>{{child.account}} </span></div>
								    <p class="msgOver1" style="cursor: auto;" v-for="content in child.content">{{content}}</p>
								</div>				
							</div>			
						</div>
					</div>				
				</div>			
			</div>
			<form class="answers">
		        <el-input type="textarea" v-model="liuyan" class="inputName area" rows="5" ref="content"></el-input>
		   </form>
			<div class="answers-btn"><el-button type="primary" round class="commitFirst" @click="mycommit">提交留言</el-button></div>

	    </div>
        <div class="information-hr-bottom"></div><div class="information-hr2-bottom"></div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapGetters } from 'vuex'
	export default{
		data(){
			return{
				notHave:true,
				items:[],
				isActive:false,
				hasError:false,
				currentPage:1,
				sort:'',
				total:0,
				pageSize:5,
				page:1,
				activeColor:'gray',
				changeShow:false,
				myanswer:[],
				mytime:'',
				mymsg:'',
				isShow:false,
				id:0,
				liuyan:'',
				focusCtrl: 0,  // 自动聚焦控制,变动时,执行自动聚焦指令
                currentIndex: 0, // 当前聚焦元素的索引
                actionType: 'next', // 自动聚焦的行为类型
                type:'',
                nowReply:[],
                account:'',
                read_status:'',
                sendType:'',
                myid:''
			}
		},
		computed:{
			...mapGetters([
					'imgUrl','name'
				]),
		},
		methods:{
			init(sort,page,read_status,sendType){
				if(read_status == ''){
					read_status = 0
				}
				if(sendType == ''){
					sendType = 2
				}
				var form = new FormData
				form.append('sort',sort)
				form.append('page',page)
				form.append('pageSize',this.pageSize)
				form.append('read_status',read_status)
				form.append('type',sendType)
				axios({
					method:'post',
					url:process.env.BASE_URL+'/letter/lists',
					data:form,
					withCredentials:true
				})
				.then(res =>{
					if (res.data.code == 10000) {
						this.total = res.data.data.total
						this.items = res.data.data.rows
						for (var i = 0; i < this.items.length; i++) {
							if (this.items[i].is_read == 0) {
								this.items[i].color = '#f00'
								this.items[i].ifread = '未读'
							} else if (this.items[i].is_read == 1){
								this.items[i].color = '#333'
								this.items[i].ifread = '已读'
							}
							if(this.items[i].type == 1){
                                this.items[i].ifread = ' '
							}
						}

					}					
				})
			},
			spread(item){
				this.$nextTick(function(){	
					if (item.change == true) {
						item.change = false					
					    this.items.push()
					} else if(item.change == false){
						item.change = true					
					    this.items.push()
					} else if(item.change == undefined){
						item.change = true
						this.items.push()
					}
				})
			},
			replay(item){
               this.oneRead(item.id)
               this.nowReply=item
               axios({
					method:'get',
					url:process.env.BASE_URL+'/letter/getReplyDeatail?id='+item.id+'',
					withCredentials:true
				})
				.then(res =>{
					if (res.data.code == 10000) {
						this.myanswer = res.data.data.rows.slice(1)						
						var content = new Array()
						for (var i = 0; i < this.myanswer.length; i++) {
							content = this.myanswer[i].content.split('\n')
							this.myanswer[i].content = content
						}
                        var myinfo = res.data.data.rows[0]
						this.mytime = myinfo.created_at
						var strs = new Array()
						strs = myinfo.content.split('\n')
						this.mymsg = strs
						this.type = myinfo.type
						this.account = myinfo.account
						this.myid = myinfo.id
					}
						
				})
				this.isShow = true 
				var _this=this
				setTimeout(function(){
					_this.$refs.content.focus()
				},100)
                
                this.id = item.id
				if (item.type == 2) {
					
					this.liuyan = '@管理员|' + item.account + '： '
					this.focusCtrl = 0
					this.currentIndex = 0
					this.setFocus()
					this.setFocusIndex()
				} else{
					this.liuyan = '@我' + '： '
					this.focusCtrl = 0
					this.currentIndex = 0
					this.setFocus()
					this.setFocusIndex()
				}
			},
			replayN(id,type,account){
				this.id = id
				if (type == 2) {
					this.liuyan = '@管理员|' + account + '： '
					this.focusCtrl = 0
					this.currentIndex = 0
					this.setFocus()
					this.setFocusIndex()
				} else{
					this.liuyan = '@我' + '： '
					this.focusCtrl = 0
					this.currentIndex = 0
					this.setFocus()
					this.setFocusIndex()
				}
				var _this=this
				setTimeout(function(){
					_this.$refs.content.focus()
				},100)
			},
			oneRead(id){//单条已读
		    	axios({
		    		method:'post',
		    		url:process.env.BASE_URL+'/letter/read-one?id='+id+'',
		    		withCredentials:true,
		    	})
		    	.then(res =>{
		    		if(res.data.code == 10000){
		    			if (this.sort == '') {
		    				this.init(1,this.page,this.read_status,this.sendType)
		    			} else{
		    				this.init(this.sort,this.page,this.read_status,this.sendType)
		    			}
		    			
		    		}else {
		    			this.$message(res.data.message)
		    		}
		    	})
		    },
			mycommit(){				
				
					var forms = new FormData
					forms.append('id',this.id)
					forms.append('content',this.liuyan)
					axios({
						method:'post',
						url:process.env.BASE_URL+'/letter/add',
						data:forms,
						withCredentials:true
					}).then(res =>{
						if(res.data.code == 10000){
							this.replay(this.nowReply)
							// this.init(this.sort,this.type,this.page,this.pageSize)
						    this.$message({
					          message: '回复成功',
					          type: 'success'
					       });
						    this.content = ''


						}
					})
			},
			handleSizeChange(val) {
		         console.log(`每页 ${val} 条`);
		    },
		    handleCurrentChange(val) {
		    	this.page = val
		        if (this.sort == '') {
    				this.init(1,val,this.read_status,this.sendType)
    			} else{
    				this.init(this.sort,val,this.read_status,this.sendType)
    			}
		    },
		    //全部已读
		    readAll(){
		    	axios({
		    		method:'post',
		    		url:process.env.BASE_URL+'/letter/read-all',
		    		withCredentials:true,
		    	})
		    	.then(res =>{
		    		if(res.data.code == 10000){
		    			if (this.sort == '') {
		    				this.init(1,this.page,this.read_status,this.sendType)
		    			} else{
		    				this.init(this.sort,this.page,this.read_status,this.sendType)
		    			}
		    			
		    		}else {
		    			this.$message(res.data.message)
		    		}
		    	})
		    },
		    //删除通知
		    deleteLetter(item){
		    	this.$confirm('此操作将删除该通知, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		        	var form2 = new FormData
			    	form2.append('id',item.id)
			    	axios({
			    		method:'post',
			    		url:process.env.BASE_URL+'/letter/delete',
			    		data:form2,
			    		withCredentials:true
			    	})
			    	.then(res=>{
			    		if(res.data.code == 10000){
			    			if (this.sort == '') {
			    				this.init(1,this.page,this.read_status,this.sendType)
			    			} else{
			    				this.init(this.sort,this.page,this.read_status,this.sendType)
			    			}
			    			
			    		}else {
			    			this.$message(res.data.message)
			    		}
			    	})

		        }).catch(() => {
		            this.$message({
			            type: 'info',
			            message: '已取消删除'
			          });       
		        });		
		    },
			setFocus(actionType,index) {
                if (actionType === 'jump') {
                    this.currentIndex = index
                }
                this.focusCtrl++
                this.actionType = actionType
            },
            setFocusIndex(index) {
                this.currentIndex = index
            }
		},
		created(){
			// 需要重置下 			
			this.init(1,this.page,this.read_status,this.sendType)
			this.$store.commit('SET_ISBLUEACTIVE', false)
//			this.$store.commit('SET_ADMINLEFTNAVNUM','/message/privateLetter')
		},
		watch:{
			sort:function(){
				this.init(this.sort,this.page,this.read_status,this.sendType)
			},
			read_status:function(){
                if(this.sort == ''){
                    this.init(1,this.page,this.read_status,this.sendType)
                }else{
                    this.init(this.sort,this.page,this.read_status,this.sendType)
                }	
			},
			sendType:function(){
                if(this.sort == ''){
                    this.init(1,this.page,this.read_status,this.sendType)
                }else{
                    this.init(this.sort,this.page,this.read_status,this.sendType)
                }	
			},

		}
	}
</script>

<style scoped>
.letter-main{ background: #fff; overflow: hidden; font-size: 14px; margin: 0 10px 0 0; border-bottom:1px solid #ebeef5; padding: 15px 0;}
.letter-read{ width: 55px; float: left; text-align: center; line-height: 50px; height: 50px;}  
.letter-img{ width: 50px; float: left; }
.letter-info{ width: 555px; float: left; padding:0 10px;}
.letter-right{ width: 150px; float: left; }
.letter-name{ font-weight: bold; margin: 3px 0 8px;}
.letter-text{ white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;}
.letter-more{ padding-top: 15px; text-align: center; }
.letter-more span{ padding: 0 8px; display: inline-block; color: #409EFF; cursor: pointer;}
.answers-btn{ text-align: center; padding: 20px 0; }
.w150{ width: 150px; }
.mb20{ margin-bottom: 20px; }
.privatetip{ padding: 25px 10px; text-align: right;}
.letter-div-1{ border-bottom: 1px dashed #eae6e6; }
.answers{ width: 770px; margin: 25px auto 0; }
.morename{ padding-top: 10px; font-weight: bold; font-size: 14px;}
.anname{ color: #ffa229; }
	.letter{
		background: #FAFAFA;
		min-height: 500px; padding-left: 20px; margin-top: -286px; padding-bottom: 30px;
	}
	.personIcon{
		width: 50px;
		height: 50px; display: block;
	}
	.div{
		background: white;
		box-shadow: 3px 3px 3px #e7e7e7; border-left: 2px solid #ffcc80;
		position: relative;
		margin-top: 30px;
		width: 770px;
		margin-left: 35px; padding-bottom: 15px;
	}
	.close{
		position: absolute;
		top: -10px;
		right: -10px;
	}
	.rightMsg{
		width: 600px;
		margin-left: 90px; padding-top: 10px;		
	}
	.msgOver{
	    cursor: pointer;
	    width: 645px;
	    word-break: break-all;	    
	    overflow: hidden;
	    font-size: 14px;
	    color: #434242;
	    line-height: 21px; 
	}
	.msgOver:last-child{
		border-bottom: 1px dashed #eae6e6; padding-bottom: 10px;
	}
	.msgOver1{ font-size: 14px; color: #666;}
	.time{
		float: right; font-size: 14px; color: #9f9f9f; padding-right: 15px;
	}
	.active{
		overflow: auto;
		display: block;
	}	
	.pai{
		margin-left: 450px;
		padding-top: 30px;
	}
	.div1{ overflow: hidden; position: relative; }
	.rightMsg1{ float: left; width: 525px; }
	.div1 .time{ position: absolute; right: 0; top: 0; padding: 0; }

	.fen{
		width: 520px;
		margin: 40px auto;
		padding-bottom: 50px;
	}
	.letterimg{
		width: 50px;
		height: 50px;
		float: left;
		padding: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/views/privateLetter.vue